export const WELCOME_MESSAGE_ID = 'intl-msg:chatbot.welcome';

export const RECOVERY_MESSAGE_ID = 'intl-msg:chatbot.recovery';

// Must match the exact text the backend returns when it cannot answer
export const RECOVERY_MESSAGE =
    'Unfortunately, I do not have information on that subject at the moment. Please reach out to the team on the #mdmsupport Slack channel for further assistance.';
